import "./Footer.css";

function Footer(props) {
  const date = new Date();

  return (
    <>
      {props.hideIconSidebar === true && (
        <>
          <div className="footer_icons_container">
            <a
              href="https://www.instagram.com/greenpay_network/"
              target="_blank"
            >
              {/* <!-- {instagram} --> */}
              <div className="footer_icons_container_child">
                <div className="footer_icons_container_left instagram_footer">
                  Instagram
                </div>
                <div className="footer_icons_container_Icon_div ">
                  <i className="fa fa-instagram"></i>
                </div>
              </div>
            </a>

            {/* <!-- {facebook} --> */}

            <a
              href="https://www.facebook.com/Greenpay-Network-Private-Limited-107365218579843"
              target="_blank"
            >
              <div className="footer_icons_container_child">
                <div
                  className="footer_icons_container_left"
                  style={{ backgroundColor: "#4267B2" }}
                >
                  facebook
                </div>
                <div className="footer_icons_container_Icon_div">
                  <i className="fa fa-facebook"></i>
                </div>
              </div>
            </a>

            <a
              href="https://www.linkedin.com/company/80006869/admin/"
              target="_blank"
            >
              <div className="footer_icons_container_child">
                <div
                  className="footer_icons_container_left"
                  style={{ backgroundColor: "#0077b5" }}
                >
                  linkedin
                </div>

                <div className="footer_icons_container_Icon_div">
                  <i className="fa fa-linkedin"></i>
                </div>
              </div>
            </a>

            <a
              href="https://www.youtube.com/channel/UC0R6TG6cpxrMOra-1tVJJdw"
              target="_blank"
            >
              <div className="footer_icons_container_child">
                <div
                  className="footer_icons_container_left"
                  style={{ backgroundColor: "#FF0000" }}
                >
                  youtube
                </div>

                <div className="footer_icons_container_Icon_div">
                  <i className="fa fa-youtube-play"></i>
                </div>
              </div>
            </a>
          </div>
        </>
      )}

      <footer className="Footer">
        <div className="FooterLinks">
          <a
            href="https://greenpaynetwork.co.in/terms&Conditions.html"
            target="blank"
          >
            Terms and Conditions
          </a>
          <a
            href="https://greenpaynetwork.co.in/privacyPolicy.html"
            target="blank"
          >
            Privacy Policy
          </a>
          <a
            href="https://greenpaynetwork.co.in/refundPolicy.html"
            target="blank"
          >
            Refund & Cancellation Policy
          </a>
          <a
            href="https://greenpaynetwork.co.in/contactUs.html"
            target="blank"
          >
            Contact Us
          </a>
        </div>
        <p className="Footer_info">
          All Rights Reserved. © {date.getFullYear()} GREENPAY NETWORK PVT LTD.
          | Design by Greenpay Tech
        </p>
      </footer>
    </>
  );
}
export default Footer;
